export default __webpack_public_path__ + "static/media/Baby33.a3309a0c.gif";